import { Component, OnInit } from '@angular/core';
import { ShService } from '../../services/sh-service';
import { SharedModule } from '../../shared/shared.module';
import { ApiDataService } from '../../services/api.service';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-notification',
    imports: [SharedModule],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit {
  notifications: any;
  currentProfile: number = -1;
  currentRole: any = '';
  currentOrg: string = '';
  labels: any;
  loader: boolean = false;
  currentLob: string = '';

  constructor(
    private _service: ShService,
    private _apiService: ApiDataService,
    private router: Router
  ){}

  ngOnInit(): void {
    this.currentLob = sessionStorage.getItem('currentLob') || ''
    this.currentRole = sessionStorage.getItem('role') || '';
    this.currentRole = parseInt(this.currentRole);
    this.labels = JSON.parse(sessionStorage.getItem('labels') as any);
    this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');
    this.currentOrg = sessionStorage.getItem('org') || '';
    this._service.notificationLoader$.subscribe(x => {
      this.loader = x;
    })
    this._service.localNotification$.subscribe(x => {
      if(x){
        this.notifications = x;
        this.notifications.filter((x: any) => {
          x.action = x.action && this.currentRole !== 3 && ((this.currentProfile !== 0 && x.type === 'OUT OF MARKET') || (this.currentProfile === 1 && x.type === 'NO LABEL'));
        });
      }
    })
  }

  download(item: any){
      const PAYLOAD = {
        orgId: item.orgId,
        bol: item.transferId,
        type: item.type,
        destination: item.destination
      }
  
      this._apiService.downloadTransfer(PAYLOAD).subscribe(x => {
        
      }, (error) => {
        let blob = new Blob([error.error.text], {type: 'text/csv' });
        saveAs(blob, item.transferId+'.csv');
      });
    }

  dismiss(id: number){
    const PAYLOAD = {
      orgId: this.currentProfile? this.currentOrg : null,
      id: id,
      lob: this.currentLob
    }
    this._apiService.dismissNotification(PAYLOAD).subscribe(x => {
      this.notifications = this.notifications.filter((y: any) => y.id !== id);
      this._service.localNotification$.next(this.notifications);
    }, (error) => {
      
    })
  }

  goToTransfer(item: any){
    this.router.navigate(["/transfer"], {queryParams: {cartons: item.count, type: item.type, source: item.orgId, destination: item.destination}});
  }

}
